import axios from 'axios'

export default {
  install (vue) {
    /* This is currently setting to use axios as http only client side. Need a selector if we do both and use the http plugin for nuxt */
    const instance = axios.create({
      baseURL:process.env.VUE_APP_API_URL, // 'https://communication-worker-svcd-fhla5izm6a-uc.a.run.app', 
    })
    vue.prototype.$http = instance
  },
}
